import { render, staticRenderFns } from "./CompetitionResults.vue?vue&type=template&id=aa43619c&scoped=true"
import script from "./CompetitionResults.vue?vue&type=script&lang=js"
export * from "./CompetitionResults.vue?vue&type=script&lang=js"
import style0 from "./CompetitionResults.vue?vue&type=style&index=0&id=aa43619c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa43619c",
  null
  
)

export default component.exports